var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcTrash = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "19px",
    viewBox: "0 0 16 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin-DJ",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00306-\\u201CUser-info\\u201D-page",
    transform: "translate(-1321.000000, -702.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F8F8FB",
    x: 0,
    y: 0,
    width: 1440,
    height: 1024
  }), /*#__PURE__*/React.createElement("g", {
    id: "Skote-Dashboard-UI-Copy",
    transform: "translate(276.000000, 579.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Card",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1140,
    height: 261
  }), /*#__PURE__*/React.createElement("g", {
    id: "Table-Copy",
    transform: "translate(20.000000, 65.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bg",
    fill: "#FFFFFF",
    x: 0,
    y: 45,
    width: 1100,
    height: 43
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_trash",
    transform: "translate(1025.000000, 58.000000)",
    fill: "#F46A6A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1875,3.625 C15.3515625,3.625 15.4863281,3.57226562 15.5917969,3.46679688 C15.6972656,3.36132812 15.75,3.2265625 15.75,3.0625 L15.75,3.0625 L15.75,1.9375 C15.75,1.7734375 15.6972656,1.63867188 15.5917969,1.53320312 C15.4863281,1.42773438 15.3515625,1.375 15.1875,1.375 L15.1875,1.375 L10.96875,1.375 L10.6523438,0.70703125 C10.4882812,0.40234375 10.2304688,0.25 9.87890625,0.25 L9.87890625,0.25 L5.87109375,0.25 C5.51953125,0.25 5.26171875,0.40234375 5.09765625,0.70703125 L5.09765625,0.70703125 L4.78125,1.375 L0.5625,1.375 C0.3984375,1.375 0.263671875,1.42773438 0.158203125,1.53320312 C0.052734375,1.63867188 0,1.7734375 0,1.9375 L0,1.9375 L0,3.0625 C0,3.2265625 0.052734375,3.36132812 0.158203125,3.46679688 C0.263671875,3.57226562 0.3984375,3.625 0.5625,3.625 L0.5625,3.625 L15.1875,3.625 Z M12.9375,18.25 C13.40625,18.25 13.8046875,18.0859375 14.1328125,17.7578125 C14.4609375,17.4296875 14.625,17.03125 14.625,16.5625 L14.625,16.5625 L14.625,4.75 L1.125,4.75 L1.125,16.5625 C1.125,17.03125 1.2890625,17.4296875 1.6171875,17.7578125 C1.9453125,18.0859375 2.34375,18.25 2.8125,18.25 L2.8125,18.25 L12.9375,18.25 Z M11.25,16 C11.0859375,16 10.9511719,15.9472656 10.8457031,15.8417969 C10.7402344,15.7363281 10.6875,15.6015625 10.6875,15.4375 L10.6875,15.4375 L10.6875,7.5625 C10.6875,7.3984375 10.7402344,7.26367188 10.8457031,7.15820312 C10.9511719,7.05273438 11.0859375,7 11.25,7 C11.4140625,7 11.5488281,7.05273438 11.6542969,7.15820312 C11.7597656,7.26367188 11.8125,7.3984375 11.8125,7.5625 L11.8125,7.5625 L11.8125,15.4375 C11.8125,15.6015625 11.7597656,15.7363281 11.6542969,15.8417969 C11.5488281,15.9472656 11.4140625,16 11.25,16 Z M7.875,16 C7.7109375,16 7.57617188,15.9472656 7.47070312,15.8417969 C7.36523438,15.7363281 7.3125,15.6015625 7.3125,15.4375 L7.3125,15.4375 L7.3125,7.5625 C7.3125,7.3984375 7.36523438,7.26367188 7.47070312,7.15820312 C7.57617188,7.05273438 7.7109375,7 7.875,7 C8.0390625,7 8.17382812,7.05273438 8.27929688,7.15820312 C8.38476562,7.26367188 8.4375,7.3984375 8.4375,7.5625 L8.4375,7.5625 L8.4375,15.4375 C8.4375,15.6015625 8.38476562,15.7363281 8.27929688,15.8417969 C8.17382812,15.9472656 8.0390625,16 7.875,16 Z M4.5,16 C4.3359375,16 4.20117188,15.9472656 4.09570312,15.8417969 C3.99023438,15.7363281 3.9375,15.6015625 3.9375,15.4375 L3.9375,15.4375 L3.9375,7.5625 C3.9375,7.3984375 3.99023438,7.26367188 4.09570312,7.15820312 C4.20117188,7.05273438 4.3359375,7 4.5,7 C4.6640625,7 4.79882812,7.05273438 4.90429688,7.15820312 C5.00976562,7.26367188 5.0625,7.3984375 5.0625,7.5625 L5.0625,7.5625 L5.0625,15.4375 C5.0625,15.6015625 5.00976562,15.7363281 4.90429688,15.8417969 C4.79882812,15.9472656 4.6640625,16 4.5,16 Z",
    id: "\\uF2ED"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcTrash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_trash.50381354.svg";
export { ForwardRef as ReactComponent };